import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getHomeData } from "../../utils/home-util";

export const getHomeDatareq = createAsyncThunk("homePageData", async (res) => {
  const responce = await getHomeData(res);
  return responce.data;
});

const homeSlice = createSlice({
  name: "home",
  initialState: {
    homePageData: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomeDatareq.fulfilled, (state, action) => {
      state.loading = false;
      state.homePageData = action.payload;
      state.error = null;
    });
    builder.addCase(getHomeDatareq.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getHomeDatareq.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {} = homeSlice.actions;
export default homeSlice.reducer;
